import * as aspSettings from './aspSettings';
import * as utils from '../common/utils';
import * as units from '../common/units';
import * as settings from '../common/settings';
import * as enums from '../common/enums';
import * as consts from '../common/consts';
import { aspMngr } from '../asp/AspMngr';
import { DisplayObject } from './DisplayObject';
import { AspObject } from './AspObject';
import { IObjectsDrawer } from './interfaces';
import { TrackCoreObject } from './TrackCoreObject';
import { AnyTxtRecord } from 'dns';
import { AroPlotComponent } from 'src/app/aro/aro-plot.component';
import * as aro from '../aro/aro';
import { RtlScrollAxisType } from '@angular/cdk/platform';
import { TrackObject } from './../../../app/asp/TrackObject'
import { from } from 'rxjs';
import { useAnimation } from '@angular/animations';

export enum TrackCoreDataType {
  Trail = 'trail',
  Vector = 'vector'
}

export class TrackDisplayCoreObject extends DisplayObject {

  private prevIdentity: enums.Hostility;

  protected colorChanged: boolean = false;

  protected TextColor: number[] = [1, 1, 1, 1];
  protected TextSize: number = 1;
  protected TextToggler: boolean = true;

  public isTrackGraphicShown: boolean = false;
  public isLabelVisible: boolean = false;
  public isHooked: boolean = false;
  public isAuxVisible: boolean = false;

  constructor(aspObject: AspObject, drawer: IObjectsDrawer) {
    super(aspObject, drawer);
    let trackObject = this.aspObject as TrackCoreObject;

    this.isTrackGraphicShown = settings.userSettings.sysTrackElementsOn[consts.ANG_TRACK_DISPLAY_ELEMENT_TRACK];
    this.isLabelVisible = settings.userSettings.sysTrackElementsOn[consts.SYS_TRACK_DISPLAY_ELEMENT_LABEL];
    this.isHooked = aspSettings.selectedIds.has(trackObject.id) && settings.userSettings.userPerm == enums.Permission.ADMIN;
    this.isAuxVisible = this.isLabelVisible && this.isHooked && settings.userSettings.sysTrackElementsOn[consts.SYS_TRACK_DISPLAY_ELEMENT_AUX_LABEL];
    this.TextColor = utils.cssColorToNewmi(settings.userSettings.trackTextColor);
    this.TextSize = settings.userSettings.trackTextSize;

    this.drawData[this.aspObject.objectType].colors =
      [[1, 1, 1, 1], [1, 1, 1, 1], null, null, null, null, [1, 1, 1, 1], null, null, null, this.TextColor, this.TextColor,
      [1, 0, 0, 1], [0, 0, 1, 1]];  // per template
    this.drawData[this.aspObject.objectType].sizes = [null, null, null, null, null, null, null, null, null, null, this.TextSize, this.TextSize, null, null];
    this.drawData[TrackCoreDataType.Trail] = null;
    this.drawData[TrackCoreDataType.Vector] = null;
    this.drawData[TrackCoreDataType.Vector + 1] = null;

    this.onTrailVisibility(aspObject.isTrailVisible());
  }

  public get systemID(): any {
    let trackObject = this.aspObject as TrackCoreObject;
    return trackObject.trackID;
  }

  private setColor(color) {
    let trackObject = this.aspObject as TrackCoreObject;
    this.drawData[this.aspObject.objectType].colors[1] = color;
    if (this.drawData[TrackCoreDataType.Trail] != undefined)
      this.setGeometryDrawDataColor(this.drawData[TrackCoreDataType.Trail], this.getTrailColor());
    if (this.drawData[TrackCoreDataType.Vector + 1] != undefined)
      this.setGeometryDrawDataColor(this.drawData[TrackCoreDataType.Vector + 1], [0, 0, 0, 1]); // black
    if (this.drawData[TrackCoreDataType.Vector] != undefined)
      this.setGeometryDrawDataColor(this.drawData[TrackCoreDataType.Vector], trackObject.getColor());
  }

  private getTrailColor() {
    return utils.newmiDarkerColor(this.drawData[this.aspObject.objectType].colors[1], 0.8);
  }

  // Update of drawn item due to data update
  protected updateDrawValues() {
    let trackObject = this.aspObject as TrackCoreObject;
    // if track is not abt diable rotation;
    if (trackObject.trackType != enums.TrackType.TBM) {
      // no color change 4 these icons (set to white)
      this.setColor([1, 1, 1]);
      this.drawData[this.aspObject.objectType].rotations = [null, [Math.cos(Math.PI), Math.sin(Math.PI)], null, null, null, null, null, null, null, null, null, null, null, null];
      return;
    }
    // Updating the drawing data so the symbol will rotate as well
    this.setColor(trackObject.getColor());
    this.drawData[this.aspObject.objectType].rotations = [null, [Math.cos(trackObject.vectorHeading), Math.sin(trackObject.vectorHeading)], null, null, null, null, null, null, null, null, null, null, null, null];
  }

  // Override DisplayObject
  onDataChange(): void {
    super.onDataChange();

    let trackObject = this.aspObject as TrackCoreObject;

    if (this.drawData[TrackCoreDataType.Trail]) {
      if (this.drawer.is3D())
        this.drawData[TrackCoreDataType.Trail].location = this.getTrailGeometry();
      else
        this.drawData[TrackCoreDataType.Trail].geometry = this.getTrailGeometry();
    }

    // ageing handling
    if (trackObject.timeStamp) {
      let elapsed = (Date.now() - trackObject.timeStamp.getTime()) / 1000;
      if (elapsed > settings.userSettings.trackLifeTime) {
        console.log("Time Elapsed For: " + trackObject.id + " time elapsed: " + elapsed)
        console.log(settings.userSettings.trackLifeTime * 1000);
        trackObject.objectsPool.deleteObject(trackObject);
        return;
      }
    }
    // if (trackObject.trackType == enums.TrackType.TBM) {
    //   this.drawData[TrackCoreDataType.Vector] = null;
    // }
    // else if (trackObject.vector.points.length == 2) {
    //   if (!this.drawData[TrackCoreDataType.Vector]) {
    //     this.drawData[TrackCoreDataType.Vector] =
    //       this.createGeometryDrawData(trackObject.vector, trackObject.sensorTrack ? 1 : 2, this.drawData[trackObject.objectType].colors[1]);
    //   }
    // }

    if (trackObject.vector.points.length == 2) {
      if (!this.drawData[TrackCoreDataType.Vector + 1]) {
        this.drawData[TrackCoreDataType.Vector + 1] =
          this.createGeometryDrawData(trackObject.vector, 5, [0, 0, 0, 1]);
      }
      if (!this.drawData[TrackCoreDataType.Vector]) {
        this.drawData[TrackCoreDataType.Vector] =
          this.createGeometryDrawData(trackObject.vector, 2, trackObject.getColor());
      }
    }

    this.colorChanged = this.colorChanged || typeof this.prevIdentity == 'undefined' || this.prevIdentity != trackObject.hostility;

    if (this.colorChanged) {
      //this.setColor(trackObject.getColor());
      this.colorChanged = false;
    }

    this.prevIdentity = trackObject.hostility;
  }

  // Override DisplayObject
  isVisible() {
    if (!super.isVisible())
      return false;
    let trackObject = this.aspObject as TrackCoreObject;
    if (!settings.userSettings.identityTrackElementsOn[trackObject.hostility])
      return false;
    // return !trackObject.sensorTrack || !settings.userSettings.trackSourcesHidden.has(trackObject.trackID);
    return true;
  }

  trackFilter(trackObject) {
    if ((trackObject.trackType == enums.TrackType.ABT && !settings.userSettings.clsTrackElementsOn[consts.CLS_TRACK_DISPLAY_ELEMENT_ABT]) ||
      (trackObject.trackType == enums.TrackType.TBM && !settings.userSettings.clsTrackElementsOn[consts.CLS_TRACK_DISPLAY_ELEMENT_TBM]) ||
      (trackObject.hostility == enums.Hostility.Unkn && !settings.userSettings.identityTrackElementsOn[enums.Hostility.Unkn]) ||
      (trackObject.hostility == enums.Hostility.Pending && !settings.userSettings.identityTrackElementsOn[enums.Hostility.Pending]) ||
      (trackObject.hostility == enums.Hostility.AssumedFriend && !settings.userSettings.identityTrackElementsOn[enums.Hostility.AssumedFriend]) ||
      (trackObject.hostility == enums.Hostility.Friend && !settings.userSettings.identityTrackElementsOn[enums.Hostility.Friend]) ||
      (trackObject.hostility == enums.Hostility.Hostile && !settings.userSettings.identityTrackElementsOn[enums.Hostility.Hostile]) ||
      (trackObject.hostility == enums.Hostility.Neutral && !settings.userSettings.identityTrackElementsOn[enums.Hostility.Neutral]) ||
      (trackObject.hostility == enums.Hostility.Suspect && !settings.userSettings.identityTrackElementsOn[enums.Hostility.Suspect])) {
      if (trackObject.isInDm) {
        this.drawer.removeObjectFromDm(this);
        trackObject.isVisible = false;
        trackObject.isInDm = false;
        return false;
      }
    }
    else {
      trackObject.isVisible = true;
    }

    if (trackObject.isVisible && trackObject.isInDm == false) {
      trackObject.isInDm = true;
      this.drawer.addObjectToDm(this);
    }
    return true;
  }

  // Override DisplayObject
  onTrailVisibility(visible: boolean): void {
    let trackObject = this.aspObject as TrackCoreObject;
    if (visible) {
      if (!this.drawData[TrackCoreDataType.Trail]) {
        this.drawData[TrackCoreDataType.Trail] =
          this.createGeometryDrawData(this.getTrailGeometry(),
            (this.drawer.is3D() ? 200 : 3), this.getTrailColor());
        if (this.isVisible())
          this.drawer.addObjectToDm(this, [TrackCoreDataType.Trail], [TrackCoreDataType.Trail]); // immediate display refresh
      }
    }
    else
      this.drawData[TrackCoreDataType.Trail] = null;
  }

  // Override DisplayObject
  hookedTemplateIndex(): number {
    return 2;
  }

  // Override DisplayObject
  protected canBeHooked(): boolean {
    if (settings.userSettings.userPerm == enums.Permission.ADMIN)
      return true;
    else
      return false;
  }


  // this sitone var is made to slow down track update rate...
  prepareToDraw() {
    let trackObject = this.aspObject as TrackObject;

    if (!trackObject.isValid())
      return;
    if (!this.trackFilter(trackObject))
      return;

    let update: boolean = false;

    if (this.isTrackGraphicShown != settings.userSettings.sysTrackElementsOn[consts.ANG_TRACK_DISPLAY_ELEMENT_TRACK]) {
      this.isTrackGraphicShown = settings.userSettings.sysTrackElementsOn[consts.ANG_TRACK_DISPLAY_ELEMENT_TRACK];
      update = true;
    }
    if (this.isLabelVisible != settings.userSettings.sysTrackElementsOn[consts.SYS_TRACK_DISPLAY_ELEMENT_LABEL]) {
      this.isLabelVisible = settings.userSettings.sysTrackElementsOn[consts.SYS_TRACK_DISPLAY_ELEMENT_LABEL];
      update = true;
    }
    if (this.isHooked != (aspSettings.selectedIds.has(trackObject.id) && settings.userSettings.userPerm == enums.Permission.ADMIN)) {
      this.isHooked = (aspSettings.selectedIds.has(trackObject.id) && settings.userSettings.userPerm == enums.Permission.ADMIN);
      update = true;
    }
    if (this.isAuxVisible != (this.isLabelVisible && this.isHooked && settings.userSettings.sysTrackElementsOn[consts.SYS_TRACK_DISPLAY_ELEMENT_AUX_LABEL])) {
      this.isAuxVisible = (this.isLabelVisible && this.isHooked && settings.userSettings.sysTrackElementsOn[consts.SYS_TRACK_DISPLAY_ELEMENT_AUX_LABEL]);
      update = true;
    }

    if (settings.userSettings.userPerm == enums.Permission.USER) {
      let TextColor = utils.cssColorToNewmi(settings.userSettings.trackTextColor);
      if (this.TextColor.toString() != TextColor.toString()) {
        this.TextColor = TextColor;
        this.drawData[this.aspObject.objectType].colors[10] = TextColor;
        this.drawData[this.aspObject.objectType].colors[11] = TextColor;
        update = true;
      }
      let TextSize = settings.userSettings.trackTextSize;
      if (this.TextSize != TextSize) {
        this.TextSize = settings.userSettings.trackTextSize;
        this.drawData[this.aspObject.objectType].sizes[10] = this.TextSize;
        this.drawData[this.aspObject.objectType].sizes[11] = this.TextSize;
        update = true;
      }
      let TextToggler = settings.userSettings.trackTextToggler;
      if (this.TextToggler != TextToggler) {
        update = true
        this.TextToggler = TextToggler;
      }
    }

    if (trackObject.ForceUpdate || update) {
      trackObject.ForceUpdate = false;
      // if (trackObject.trackType == enums.TrackType.TBM)
      this.setColor(trackObject.getColor());

      let usrIndic: string = '';
      let usrIndic2: string = '';
      let isTrackPoly: boolean = false;
      if ((trackObject.threatPoly || trackObject.ip) && trackObject.sentToSmart && this.TextToggler) {
        isTrackPoly = true;
        if (trackObject.trackType == enums.TrackType.TBM) {
          usrIndic = "TBM";
          usrIndic2 = '';
        }
        else {
          if (trackObject.oprCategory != '' && trackObject.oprCategory != undefined) { // sys cls
            usrIndic = trackObject.oprCategory;
            usrIndic2 = trackObject.oprPlatform != '' || trackObject.oprPlatform != undefined ? trackObject.oprPlatform : null;
          }
          else {
            usrIndic = trackObject.sysCls;
            if (usrIndic.includes('/')) {
              usrIndic2 = usrIndic.split('/')[1];
              usrIndic = usrIndic.split('/')[0] + " /";
            }
          }
        }
      }

      let hook = this.isHooked ? ['hook-circle'] : null;
      let indic = trackObject.trackStatus == enums.TrackStatus.Normal ? null : enums.TrackStatusTitle(trackObject.trackStatus);
      let trackId: string = "ID: " + trackObject.trackID.toString();
      let alt = trackObject.geometry.z != undefined ? `${units.altitudeValue(trackObject.geometry.z, true)}${units.altitudeUnits()}` : aro.NO_VALUE;
      // let alert = isLabelVisible ? trackObject.alert : null;
      let speed = `${units.speedValue(trackObject.speed)}${units.speedUnits()}`;
      let hdg = units.headingValue(trackObject.heading, true);
      this.drawData[trackObject.objectType].values = [ // per template
        this.isLabelVisible ? ['track-db-horiz-leader'] : null, // DB main leader
        this.isTrackGraphicShown ? [trackObject.symbol] : null,
        hook, // hook
        this.isLabelVisible ? ['track-db-main-bg'] : null, // DB main area
        this.isLabelVisible ? trackId : null, // TrackId
        this.isLabelVisible ? alt : null, // altitude
        this.isAuxVisible ? ['track-db-vert-leader'] : null, // DB aux leader
        this.isAuxVisible ? ['track-db-aux-bg-small'] : null, // DB aux area
        this.isAuxVisible ? speed : null, // speed
        this.isAuxVisible ? hdg : null, // heading
        settings.userSettings.userPerm != enums.Permission.ADMIN ? usrIndic : '', // aux text
        settings.userSettings.userPerm != enums.Permission.ADMIN ? usrIndic2 : '', // aux text
        settings.userSettings.userPerm == enums.Permission.ADMIN ? indic : '', // Status Text
        trackObject.isExternal ? ['extracksym'] : null,
      ];
      this.drawer.updateObjectInDm(this);
    }
  }

  protected getLocation() {
    let trackObject = this.aspObject as TrackCoreObject;
    return new NeWMI.Geometry.Point({ x: trackObject.geometry.x, y: trackObject.geometry.y, z: trackObject.geometry.z });
  }

  protected getTrailGeometry() {
    let trackObject = this.aspObject as TrackCoreObject;
    let geometry: any = trackObject.trail.getVisibleTrail();
    geometry.points.push(this.getLocation());
    return geometry;
  }
}

